module.exports = __webpack_public_path__ + "static/img/img-1.09f9da4f.png";